const defaults = {
	nameRechercheCritere: 'hiddenRechercheCritere',
	pwd1: document.getElementById('MotdePasse'),
	pwd2: document.getElementById('MotdePasseConfirmer'),
	dqeObj2: {
		city: '#CoordonneesVM_Ville2',
		country: '#CoordonneesVM_Pays2',
		street: '#CoordonneesVM_Adresse32',
		zip: '#CoordonneesVM_CodePostal2'
	}
}